var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXCrossRoundedGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.500052 0.501404C0.776165 0.225295 1.22383 0.225295 1.49995 0.501404L11.4989 10.5002C11.775 10.7763 11.775 11.224 11.4989 11.5001C11.2228 11.7762 10.7751 11.7762 10.499 11.5001L0.500052 1.50128C0.223938 1.22517 0.223938 0.777513 0.500052 0.501404Z",
    fill: "#747B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5001 0.499938C11.7762 0.776047 11.7762 1.22371 11.5001 1.49982L1.50108 11.4986C1.22497 11.7747 0.777302 11.7747 0.501188 11.4986C0.225074 11.2225 0.225074 10.7748 0.501187 10.4987L10.5002 0.499938C10.7763 0.223828 11.2239 0.223828 11.5001 0.499938Z",
    fill: "#747B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCrossRoundedGrey);
export default __webpack_public_path__ + "static/media/x-cross-rounded-grey.15454bf863b7cffe9cb1bf048c84c831.svg";
export { ForwardRef as ReactComponent };